var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "tab-title" }, [
      _vm._v(_vm._s(_vm.$t("Sop.SopFilterContent.SopFilterConditionsTip")))
    ]),
    _vm._v(" " + _vm._s(_vm.$t("Sop.SopFilterContent.BusinessState")) + " "),
    _c(
      "div",
      { staticClass: "checkbox-group" },
      [
        _c(
          "el-checkbox-group",
          {
            on: { change: _vm.handleCheckedJobStateChange },
            model: {
              value: _vm.jobState,
              callback: function($$v) {
                _vm.jobState = $$v
              },
              expression: "jobState"
            }
          },
          _vm._l(_vm.jobs, function(item) {
            return _c(
              "el-checkbox",
              { key: item.key, attrs: { label: item.key } },
              [_vm._v(_vm._s(item.value))]
            )
          }),
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "date-wrapper" }, [
      _vm._v(" " + _vm._s(_vm.$t("Sop.SopFilterContent.Date")) + " "),
      _c(
        "div",
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("Sop.SeaExport")) +
                "：" +
                _vm._s(_vm.$t("Sop.SopFilterContent.ETD"))
            )
          ]),
          _c("el-input", {
            attrs: {
              maxlength: "2",
              oninput: "value=value.replace(/[^0-9.]/g,'')"
            },
            model: {
              value: _vm.seExpireDays,
              callback: function($$v) {
                _vm.seExpireDays = _vm._n($$v)
              },
              expression: "seExpireDays"
            }
          }),
          _vm._v(_vm._s(_vm.$t("Sop.SopFilterContent.Days")))
        ],
        1
      ),
      _c(
        "div",
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("Sop.SeaImport")) +
                "：" +
                _vm._s(_vm.$t("Sop.SopFilterContent.ETA"))
            )
          ]),
          _c("el-input", {
            attrs: {
              maxlength: "2",
              oninput: "value=value.replace(/[^0-9.]/g,'')"
            },
            model: {
              value: _vm.siExpireDays,
              callback: function($$v) {
                _vm.siExpireDays = _vm._n($$v)
              },
              expression: "siExpireDays"
            }
          }),
          _vm._v(_vm._s(_vm.$t("Sop.SopFilterContent.Days")))
        ],
        1
      ),
      _c(
        "div",
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("Sop.AirExport")) +
                "：" +
                _vm._s(_vm.$t("Sop.SopFilterContent.ETD"))
            )
          ]),
          _c("el-input", {
            attrs: {
              maxlength: "2",
              oninput: "value=value.replace(/[^0-9.]/g,'')"
            },
            model: {
              value: _vm.aeExpireDays,
              callback: function($$v) {
                _vm.aeExpireDays = _vm._n($$v)
              },
              expression: "aeExpireDays"
            }
          }),
          _vm._v(_vm._s(_vm.$t("Sop.SopFilterContent.Days")))
        ],
        1
      ),
      _c(
        "div",
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("Sop.AirImport")) +
                "：" +
                _vm._s(_vm.$t("Sop.SopFilterContent.ETA"))
            )
          ]),
          _c("el-input", {
            attrs: {
              maxlength: "2",
              oninput: "value=value.replace(/[^0-9.]/g,'')"
            },
            model: {
              value: _vm.aiExpireDays,
              callback: function($$v) {
                _vm.aiExpireDays = _vm._n($$v)
              },
              expression: "aiExpireDays"
            }
          }),
          _vm._v(_vm._s(_vm.$t("Sop.SopFilterContent.Days")))
        ],
        1
      ),
      _c(
        "div",
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("Sop.RailwayExport")) +
                "：" +
                _vm._s(_vm.$t("Sop.SopFilterContent.ETD"))
            )
          ]),
          _c("el-input", {
            attrs: {
              maxlength: "2",
              oninput: "value=value.replace(/[^0-9.]/g,'')"
            },
            model: {
              value: _vm.reExpireDays,
              callback: function($$v) {
                _vm.reExpireDays = _vm._n($$v)
              },
              expression: "reExpireDays"
            }
          }),
          _vm._v(_vm._s(_vm.$t("Sop.SopFilterContent.Days")))
        ],
        1
      ),
      _c(
        "div",
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("Sop.RailwayImport")) +
                "：" +
                _vm._s(_vm.$t("Sop.SopFilterContent.ETA"))
            )
          ]),
          _c("el-input", {
            attrs: {
              maxlength: "2",
              oninput: "value=value.replace(/[^0-9.]/g,'')"
            },
            model: {
              value: _vm.riExpireDays,
              callback: function($$v) {
                _vm.riExpireDays = _vm._n($$v)
              },
              expression: "riExpireDays"
            }
          }),
          _vm._v(_vm._s(_vm.$t("Sop.SopFilterContent.Days")))
        ],
        1
      ),
      _c(
        "div",
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("Sop.IntegratedJob")) +
                "：" +
                _vm._s(_vm.$t("Sop.SopFilterContent.ETD"))
            )
          ]),
          _c("el-input", {
            attrs: {
              maxlength: "2",
              oninput: "value=value.replace(/[^0-9.]/g,'')"
            },
            model: {
              value: _vm.integratedDays,
              callback: function($$v) {
                _vm.integratedDays = _vm._n($$v)
              },
              expression: "integratedDays"
            }
          }),
          _vm._v(_vm._s(_vm.$t("Sop.SopFilterContent.Days")))
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }